<template>
  <div class="target">
    <div class="mobileTarget" v-if="$vuetify.breakpoint.xsOnly">
      <a :class="mobileTargetClasses" :href="mobileLoginTarget" target="_blank" @click="click">
        <div class="v-btn__content">
          {{ value.name }}
        </div>
      </a>
      <div :class="mobileTargetTypeClasses">
        <a class="v-btn edvalBtn" :href="getTarget(false)" target="_blank"
           :title="value.name">{{ cloudLabel }}</a>
        <a v-if="canAccessEnterprise" class="v-btn info" :href="getTarget(true)"
           target="_blank">School manager</a>
      </div>
    </div>
    <template v-else>
      <v-subheader>{{ value.name }}</v-subheader>
      <v-spacer/>
      <a class="v-btn edvalBtn" :href="getTarget(false)" target="_blank"
         :title="value.name">{{ cloudLabel }}</a>
      <a v-if="canAccessEnterprise" class="v-btn info" :href="getTarget(true)"
         target="_blank">School manager</a>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      value: Object,
      openTarget: String
    },
    computed: {
      cloudLabel() {
        return this.canAccessEnterprise ? 'Cloud' : 'Log in';
      },
      canAccessEnterprise() {
        return !!this.user.scopes.enterprise;
      },
      mobileLoginTarget() {
        if (this.canAccessEnterprise) {
          return null;
        } else {
          return this.getTarget(false);
        }
      },
      mobileTargetClasses() {
        const classes = ['targetName', 'v-btn', 'v-btn--flat', 'v-btn--block'];
        if (this.canAccessEnterprise && this.openTarget === this.value.key) {
          classes.push('slide-out');
        }

        return classes;
      },
      mobileTargetTypeClasses() {
        const classes = ['loginTypes'];
        if (!this.canAccessEnterprise || this.openTarget !== this.value.key) {
          classes.push('slide-out');
        }

        return classes;
      },
      ...mapState('auth', [
        'user'
      ])
    },
    methods: {
      getTarget(enterprise) {
        let target = `/login/cloud/${this.value.key}`;
        if (enterprise) {
          target += '/enterprise';
        }

        return target;
      },
      click() {
        this.$emit('openTarget', this.value.key);
      }
    }
  };
</script>

<style lang="less" scoped>
  @import "../../style/variables.less";

  .target {
    display: flex;
    overflow: hidden;

    .mobileTarget {
      position: relative;
      width: 100%;
      min-height: 48px;
      @transition: 0.3s cubic-bezier(.25, .8, .50, 1);

      .targetName {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        transition: left @transition;

        &.slide-out {
          left: -100%;
        }
      }

      .loginTypes {
        position: absolute;
        width: 100%;
        top: 0;
        right: 0;
        transition: right @transition;

        &.slide-out {
          right: -100%;
        }
      }
    }

    .v-btn {
      padding: 1px 8px;
      height: unset;
      min-height: 36px;
      text-transform: none;

      &.edvalBtn {
        color: #ffffff;
        background-color: @edval-dark !important; // Specificity fight with vuetify
      }
    }
  }
</style>
